import React, { useContext, useRef, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';
import { Title, Label, TermsAndConditions } from '../Banners.styled';
import Banner, { PROMO_APPLIED, PROMO_CASINO } from '../../Components/Banner';
import { getColorFont, getFontFamily } from '../utils';
import { appliedClosed } from 'lib/targetedOffers/Banners/closedBanners';
import { getOfferInfo } from 'lib/targetedOffers/Offers';

const BannerApplied = ({ targetedOffer }) => {
  
  const { globalization } = useContext(CruiseSearchContext);
  const { isMobile } = useContext(CruiseSelectionContext);

  const { filtersDictionary, generalDictionary } =
    globalization?.dictionaries || {};
  const {
    actionForMoreInformation,
    labelCasinoRoyaleOffer,
    labelCasinoOfferJackpot,
  } = filtersDictionary;

  const {
    actionPromoAppliedClickHere,
    labelPromoAppliedDetails,
    labelPromoAppliedTitle,
  } = generalDictionary;

  const [close, setClose] = useState(false);

  const { longEndDate, link, isCasino } = getOfferInfo(targetedOffer);

  const details = labelPromoAppliedDetails.replace('{0}', longEndDate);

  const termsRef = useRef();

  function closeBanner() {
    appliedClosed(targetedOffer);
    setClose(true);
  }

  const typeBanner = useMemo(
    () => (isCasino ? PROMO_CASINO : PROMO_APPLIED),
    [isCasino],
  );

  if (close) return null;

  const getTitle = () => isCasino ? labelCasinoRoyaleOffer : labelPromoAppliedTitle;  


  const getContent = () => isCasino ? `${labelCasinoOfferJackpot} ${labelPromoAppliedTitle}` : details;

  return (
    <>
      <Banner
        onClose={closeBanner}
        type={typeBanner}
        titleBanner={
          <Title $color={getColorFont(isMobile, typeBanner)} $fontFamily={getFontFamily(isMobile)}>
            {getTitle()}
          </Title>
        }
        contentBanner={
          <>
            <Label $weight="400">{getContent()}</Label>
            {!isCasino && link && (
              <TermsAndConditions ref={termsRef} target="_blank" href={link}>
                {` ${actionForMoreInformation} `}
                {actionPromoAppliedClickHere}
              </TermsAndConditions>
            )}
          </>
        }
      />
    </>
  );
};

BannerApplied.propTypes = {
  targetedOffer: PropTypes.any,
};

BannerApplied.defaultProps = {
  targetedOffer: {},
};

export default BannerApplied;
